import {
  ApplicationButtonConfigType,
  ApplicationStatus,
  ApplicationStatusEvent
} from "../../../Graphql/types/application";

const {
  INTERVIEW,
  OFFER,
  ON_HOLD,
  SUBMITTED,
  NOT_CONSIDERED,
  NOT_SELECTED,
  WITHDRAWN,
  VIEWED
} = ApplicationStatus;

export const ApplicationButtonConfig: ApplicationButtonConfigType[] = [
  {
    title: "Withdraw",
    allowedActions: [INTERVIEW, OFFER, SUBMITTED, VIEWED],
    event: ApplicationStatusEvent.WITHDRAW,
    color: "primary"
  },
  {
    title: "Move to next Step",
    allowedActions: [INTERVIEW, OFFER, SUBMITTED, VIEWED],
    event: ApplicationStatusEvent.NEXT_STEP,
    color: "info"
  },
  {
    title: "Reject",
    allowedActions: [INTERVIEW, VIEWED],
    event: ApplicationStatusEvent.REJECT,
    color: "error"
  },
  {
    title: "Put on hold",
    allowedActions: [INTERVIEW, OFFER, SUBMITTED, VIEWED],
    event: ApplicationStatusEvent.ON_HOLD,
    color: "primary"
  },
  {
    title: "Reset",
    allowedActions: [WITHDRAWN, NOT_CONSIDERED, NOT_SELECTED, ON_HOLD],
    event: ApplicationStatusEvent.RESET,
    color: "primary"
  }
];
